import MyCustomValidation from "../Js/Validation";

export interface ITblMStaffRoleData {
  menuName?: string;
  staffName?: string;
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  id?: number;
  staffCode?: string;
  url?: string;
  roleKbn?: number;
  kbn?: number;
  delFlg?: number;
  addDate?: Date | null | undefined;
  addUser?: string;
  updDate?: Date | null | undefined;
  updUser?: string;
}

export class TblMStaffRole {
  menuName?: string;
  staffName?: string;
  pkCompanyCode?: string;
  pkOfficeCode?: string;
  pkServiceType?: string;
  id?: number;
  staffCode?: string;
  url?: string;
  roleKbn?: number;
  kbn?: number;
  delFlg?: number;
  addDate?: Date | null | undefined;
  addUser?: string;
  updDate?: Date | null | undefined;
  updUser?: string;

  constructor(data: ITblMStaffRoleData = {}) {
    this.menuName = data.menuName || "";
    this.staffName = data.staffName || "";
    this.pkCompanyCode = data.pkCompanyCode || "";
    this.pkOfficeCode = data.pkOfficeCode || "";
    this.pkServiceType = data.pkServiceType || "";
    this.id = data.id || 0;
    this.staffCode = data.staffCode || "";
    this.url = data.url || "";
    this.roleKbn = data.roleKbn || 0;
    this.kbn = data.kbn || 0;
    this.delFlg = data.delFlg || 0;
    this.addDate = data.addDate || null;
    this.addUser = data.addUser || "";
    this.updDate = data.updDate || null;
    this.updUser = data.updUser || "";
  }

  clear(): void {
    this.menuName = "";
    this.staffName = "";
    this.pkCompanyCode = "";
    this.pkOfficeCode = "";
    this.pkServiceType = "";
    this.id = 0;
    this.staffCode = "";
    this.url = "";
    this.roleKbn = 0;
    this.kbn = 0;
    this.delFlg = 0;
    this.addDate = null;
    this.addUser = "";
    this.updDate = null;
    this.updUser = "";
  }

  // カスタムバリデーションメソッド
  validate(): string[] {
    const errors: string[] = [];

    let validation = new MyCustomValidation(this.staffCode)
      .validateRequired("スタッフコードは必須です。")
      .validateNumeric("スタッフコードを正しく入力してください。")
      .validateStringRange(
        "1",
        "9999999999",
        "スタッフコードを正しく入力してください。",
      );
    if (validation.hasErrors()) {
      errors.push(validation.getErrors()[0]);
    }

    return errors;
  }
}
